import React from "react";
import { Typography } from "@mui/material";

// Use a fragment so you can return multiple Typography blocks, making it very readable
const LegalTerms = () => (
  <>
    <Typography variant="h6" gutterBottom>
              Terms and Conditions
            </Typography>
            <Typography variant="body2" paragraph>
              Last updated February 19, 2025
            </Typography>
            <Typography variant="body2" paragraph>
              AGREEMENT TO OUR LEGAL TERMS
              <br />
              We are Doors, Inc., doing business as Tenant Guided Tours
              ("Company," "we," "us," "our"), a company registered in Colorado,
              United States at 600 17th Street, Suite 2804V, Denver, CO 80202.
              We operate the website http://www.tenantguidedtours.com (the
              "Site"), as well as any other related products and services that
              refer or link to these legal terms (the "Legal Terms")
              (collectively, the "Services"). Tenant Guided Tours provides
              automated rental showing services for renters and rental property
              owners/managers and keyless access management. Showing service
              orders are opened when needed, covers all showings until property
              has leased to generate a showing link and closed when your rental
              property has leased to a new tenant. Showing service orders are as
              needed with a one-time fee. Keyless access management software is
              used for ongoing remote access management functions for tenant
              use, maintenance use, property management and property owners. You
              can contact us by phone at 18003468999, email at
              info@mytenantaccess.com, or by mail to 600 17th Street , Suite
              2804V, Denver, CO 80202, United States. These Legal Terms
              constitute a legally binding agreement made between you, whether
              personally or on behalf of an entity ("you"), and Doors, Inc.,
              concerning your access to and use of the Services. You agree that
              by accessing the Services, you have read, understood, and agreed
              to be bound by all of these Legal Terms. IF YOU DO NOT AGREE WITH
              ALL OF THESE LEGAL TERMS, THEN YOU ARE EXPRESSLY PROHIBITED FROM
              USING THE SERVICES AND YOU MUST DISCONTINUE USE IMMEDIATELY. We
              will provide you with prior notice of any scheduled changes to the
              Services you are using. The modified Legal Terms will become
              effective upon posting or notifying you by
              info@mytenantaccess.com, as stated in the email message. By
              continuing to use the Services after the effective date of any
              changes, you agree to be bound by the modified terms. The Services
              are intended for users who are at least 18 years old. Persons
              under the age of 18 are not permitted to use or register for the
              Services. We recommend that you print a copy of these Legal Terms
              for your records.
            </Typography>

            <Typography variant="body2" gutterBottom>
              <strong>TABLE OF CONTENTS</strong>
            </Typography>
            <Typography variant="body2" component="ol" sx={{ pl: 3, mb: 2 }}>
              <li>OUR SERVICES</li>
              <li>INTELLECTUAL PROPERTY RIGHTS</li>
              <li>USER REPRESENTATIONS</li>
              <li>USER REGISTRATION</li>
              <li>PURCHASES AND PAYMENT</li>
              <li>SUBSCRIPTIONS</li>
              <li>PROHIBITED ACTIVITIES</li>
              <li>USER GENERATED CONTRIBUTIONS</li>
              <li>CONTRIBUTION LICENSE</li>
              <li>THIRD-PARTY WEBSITES AND CONTENT</li>
              <li>ADVERTISERS</li>
              <li>SERVICES MANAGEMENT</li>
              <li>PRIVACY POLICY</li>
              <li>DMCA NOTICE AND POLICY</li>
              <li>TERM AND TERMINATION</li>
              <li>MODIFICATIONS AND INTERRUPTIONS</li>
              <li>GOVERNING LAW</li>
              <li>DISPUTE RESOLUTION</li>
              <li>CORRECTIONS</li>
              <li>DISCLAIMER</li>
              <li>LIMITATIONS OF LIABILITY</li>
              <li>INDEMNIFICATION</li>
              <li>USER DATA</li>
              <li>ELECTRONIC COMMUNICATIONS</li>
              <li>SMS TEXT MESSAGING</li>
              <li>CALIFORNIA USERS AND RESIDENTS</li>
              <li>MISCELLANEOUS</li>
              <li>HOLD HARMLESS AND WAIVER OF LIABILITY</li>
              <li>WARRANTY DISCLAIMER/INTELLECTUAL RIGHTS</li>
              <li>CONTACT US</li>
            </Typography>
  </>
);

export default LegalTerms;
